import React from 'react';
import "./styleCategory.css";
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';

import ReactCrop, {
    centerCrop,
    makeAspectCrop,
    Crop,
    PixelCrop,
    convertToPixelCrop,
} from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import { useRef } from 'react';
import { deleteCategory, postCategory, updateCategory } from '../../../services/categoryServices';
import { setCategoryList, setIsAddCategory } from '../../../features/platforms/platformsSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import { getCategoryList } from '../../../services/platformServices';


// This is to demonstate how to make and center a % aspect crop
// which is a bit trickier so we use some helper functions.
function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
        makeAspectCrop({ unit: '%' }, aspect, mediaWidth, mediaHeight),
        mediaWidth,
        mediaHeight
    );
}
function INCSUBCategory() {
    const [isAddTogle, setIsAddToggle] = useState(false)
    const categoryList = useSelector((state) => state.platforms.categoryList);
    const [categoryName, setCategoryName] = useState('')
    const [imgSrc, setImgSrc] = useState('');
    const previewCanvasRef = useRef(null);
    const imgRef = useRef(null);
    const hiddenAnchorRef = useRef(null);
    const blobUrlRef = useRef('');
    const [crop, setCrop] = useState(null);
    const [completedCrop, setCompletedCrop] = useState(null);
    const [aspect] = useState(1 / 1);
    const [croppedImageUrl, setCroppedImageUrl] = useState(null);
    const [blobImgFile, setBlobImgFile] = useState();
    const dispatch = useDispatch();
    const [categoryId, setCategoryId] = useState();
    const [isOpenPopUp, setIsOpenPopup] = useState(false);
    const [isAsk, setIsAsk] = useState(false);
    const [index, setIndex] = useState(null);
    const navigate = useNavigate();
    const [imageError, setImageError] = useState()

    function onSelectFile(e) {
        if (e.target.files && e.target.files.length > 0) {

            const file = e.target.files[0];

            // Create a new Blob (optional, as file is already a Blob)
            const blob = new Blob([file], { type: file.type });
            // Store the blob in state (assuming you have a setBlob state setter)
            // setnewNotification((prev) => ({
            //     ...prev,
            //     customNotificationImageFile: blob,
            // }))
            setBlobImgFile(blob)
            // Convert the file to a Data URL for image preview
            const reader = new FileReader();
            // reader.addEventListener('load', () => {
            //     setnewNotification((prev) => ({
            //         ...prev,
            //         customNotificationImage: reader.result?.toString() || '',
            //     })
            //     )
            // });

            reader.onload = function (event) {
                const img = new Image();
                img.onload = function () {
                    const aspectRatio = img.width / img.height;
                    const targetRatio = 1 / 1;

                    // Allow for a small tolerance due to potential rounding
                    const tolerance = 0.01;
                    if (Math.abs(aspectRatio - targetRatio) > tolerance) {
                        setImageError(true);

                    } else {
                        setImageError(false);
                    }


                    const blob = new Blob([file], { type: file.type });
                    // setnewNotification((prev) => ({
                    //     ...prev,
                    //     customNotificationImage: reader.result?.toString() || '',
                    // })

                    // )
                    setCroppedImageUrl(reader.result?.toString() || '')
                };
                img.src = event.target.result;
            };
            reader.readAsDataURL(file);
        }
    }



    function onImageLoad(e) {
        if (aspect) {
            const { width, height } = e.currentTarget;
            setCrop(centerAspectCrop(width, height, aspect));
        }
    }

    async function onDownloadCropClick() {
        const image = imgRef.current;
        const previewCanvas = previewCanvasRef.current;

        if (!image || !previewCanvas || !completedCrop?.width || !completedCrop?.height) {
            console.error("Crop canvas does not exist or is incomplete.");
            return;
        }

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        // Create an offscreen canvas
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        if (!ctx) {
            console.error("No 2D context on canvas.");
            return;
        }

        canvas.width = completedCrop.width * scaleX;
        canvas.height = completedCrop.height * scaleY;

        ctx.drawImage(
            image,
            completedCrop.x * scaleX,
            completedCrop.y * scaleY,
            completedCrop.width * scaleX,
            completedCrop.height * scaleY,
            0,
            0,
            canvas.width,
            canvas.height
        );

        canvas.toBlob((blob) => {
            if (!blob) {
                console.error("Failed to create blob from cropped image.");
                return;
            }

            if (blobUrlRef.current) {
                URL.revokeObjectURL(blobUrlRef.current);
            }
            blobUrlRef.current = URL.createObjectURL(blob);

        }, 'image/png');


        canvas.toBlob(async (blob) => {
            if (!blob) {
                console.error("Failed to create Blob from canvas.");
                return;
            }
            const randomName = Math.random().toString()
            const formData = new FormData();
            formData.append('image', blob, `${randomName}${categoryName}.png`);
            setBlobImgFile(blob)

        }, 'image/png');


        const croppedImageUrl = canvas.toDataURL('image/png');
        setCroppedImageUrl(croppedImageUrl);
    }
    const [categoryLoader, setCategoryLoader] = useState(false)
    const [error, setError] = useState(false)
    const addCategoryData = async () => {
        console.log(!categoryId)
        if (categoryName === '') {
            setError(true)
            toast.error("Please enter category name");
            return
        }
        if (!croppedImageUrl) {
            setError(true);
            toast.error("Please select category image");
            return
        }

        if (!categoryId) {
            setCategoryLoader(true)
            const data = await postCategory(categoryName, blobImgFile);
            // Check if the API call was successful
            if (!data) {
                console.error("Failed to add category. No data returned.");
                return;
            }
            if (data.status === 201) {
                // Create a new array instead of mutating existing state
                const updatedCategoryList = [...categoryList, {
                    categoryId: data.data.data.categoryId,  // Use backend-generated ID
                    categoryName: categoryName,
                    categoryImage: croppedImageUrl,  // Keep frontend image for preview
                }];
                setBlobImgFile(null);
                setCroppedImageUrl(null)
                setCategoryName('');
                setError(false);
                dispatch(setCategoryList(updatedCategoryList));
                setIsAddToggle(false)
            } else if (data.status === 401) {
                navigate('login')
                window.localStorage.getItem('userData', null);

            } else {
                toast.error(data.data.message)
            }
            setCategoryLoader(false)

        } else {
            if (categoryList[index].categoryName !== categoryName || blobImgFile) {
                const data = await updateCategory(categoryId, categoryName, croppedImageUrl, blobImgFile);
                if (!data) {
                        toast.error("Something went wrong")
                    return;
                }
                if (data === 200) {
                    const updatedCategory = {
                        categoryId: categoryId,
                        categoryName: categoryName,
                        croppedImageUrl: croppedImageUrl,
                        blobImgFile: blobImgFile
                    }
                    const updatedList = categoryList.map(category =>
                        category.categoryId === updatedCategory.categoryId
                            ? { ...category, ...updatedCategory } // Update matched category
                            : category
                    );
                    dispatch(setCategoryList(updatedList))
                    setIsAddToggle(false);
                    setCroppedImageUrl(null);
                    setCategoryId(null);
                    setCategoryName(null);
                    setCroppedImageUrl(null);
                    setIsAddToggle(false)
                }
                else if (data.status === 301) {
                    toast.error("Network Error");
                } else if (data.status === 500) {
                    toast.error("Internal server error");
                } else if (data.status === 401) {
                    navigate('/login');
                    window.localStorage.clear();
                } else {
                    toast.error("Something went wrong")
                }
            }

        }

    };

    const handleDeleteCategory = async (categoryId) => {
        setCategoryLoader(true)
        const data = await deleteCategory(categoryId);
        if (!data) {
            toast.error("Failed to add category. No data returned.");
            setCategoryLoader(true)
            return;
        }
        if (data === 200) {
            const filteredData = categoryList.filter((category) => category.categoryId !== categoryId);
            dispatch(setCategoryList(filteredData))
            setCategoryLoader(false);
            setIsOpenPopup(false);
            setIsAsk(false);

        } else if (data.status === 401) {
            navigate('/login')
            window.localStorage.clear();
        } else if (data.status === 301) {
            toast.error("Network Error");
        } else if (data.status === 500) {
            toast.error("Internal server error");
        } else if (data === 403) {
            setIsAsk(false)
            setCategoryLoader(false)
        } else {
            try {
                const data = await getCategoryList();
                dispatch(setCategoryList(data));

            } catch (error) {
                toast.error("Error fetching CategoryList list");
            }
             setCategoryLoader(false)
        }
    }

    const handleCategoryName = (e) => {
        setCategoryName(e.target.value);
    }
    const handleEditCategory = (category) => {
        setCategoryId(category.categoryId);
        setCategoryName(category.categoryName);
        setCroppedImageUrl(category.categoryImage);
        setIsAddToggle(true);
    }
    return (
        <div className='INCSUBCategory'>
            <div className='INCSUBCategory_container'>
                <div className='INCSUBCategory_add_container'>
                    <div className='INCSUBCategory_header_container'>
                        <h1>Categories</h1>
                        <svg onClick={() => dispatch(setIsAddCategory(false))} width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.6074 10.6328L23.3353 23.3607" stroke="#8B8B8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.6074 23.3672L23.3353 10.6393" stroke="#8B8B8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>

                    <div className='INCSUBCategory_add_operation_container'>{
                        !isAddTogle ? <div className='INCSUBCategory_add_category_btn' onClick={() => setIsAddToggle(true)}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 1.78125V17.7812" stroke="#4880FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2 9.78125L18 9.78125" stroke="#4880FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Add New Categories
                        </div> : <div className='INCSUBCategory_input_container'>
                            <input className='INCSUBCategory_input_name' placeholder='Enter Categories Name' value={categoryName} onChange={handleCategoryName} style={{ border: error && categoryName === '' ? "1px solid red" : null }}></input>
                            <div className="INCSUBAddTrendingPlatform_image_container">
                                <div className="INCSUBCategory_image">
                                    <input type="file" accept="image/*" onChange={onSelectFile} />
                                    <svg
                                        width="37"
                                        height="37"
                                        viewBox="0 0 37 37"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M18.5 7.71094V29.2943"
                                            stroke="#606060"
                                            strokeWidth="3.08333"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M7.7085 18.5H29.2918"
                                            stroke="#606060"
                                            strokeWidth="3.08333"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>{
                                        croppedImageUrl && <img className='INCSUBDisplay_img' src={croppedImageUrl} alt='/' />
                                    }

                                </div>
                                <div className="INCSUBCategory_image_ratio">
                                    JPG, PNG / Size. 1:1 {imageError ? <div style={{ color: "red" }}> Image size should be in 1:1 ratio</div> : null}
                                </div>

                            </div>
                            <div className="INCSUBCategory_image_upload_btn">
                                <div className='upload_cancel_btn' onClick={() => {
                                    setIsAddToggle(false);
                                    setCroppedImageUrl(null);
                                    setCategoryId(null);
                                    setCategoryName(null);
                                    setCroppedImageUrl(null);
                                }}>Cancel</div>
                                <div className='INCSUBCategory_upload_btn' onClick={!categoryLoader ? addCategoryData : null}>{!categoryLoader ? (categoryId ? "Update" : "Add") : <div className='categoryLoader' />}</div>
                            </div>
                        </div>
                    }

                    </div>
                    <div className='INCSUBCategory_operations_container'>
                        <div className='INCSUBCategory_list_container'>
                            <div className='INCSUBCategory_type_filter_list'>
                                <ul>
                                    {
                                        categoryList && categoryList.length > 0 && categoryList.map((category, index) => <div className='INCSUBCategory_list' style={{ background: category.categoryName === categoryName ? "#F4F8FF" : null }}>
                                            <li key={category.categoryId}>{category.categoryName}</li>
                                            <div className='INCSUBCategory_crud_btns '>
                                                <svg onClick={() => {
                                                    handleEditCategory(category)
                                                    setIndex(index)
                                                }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10 16.6562H17.5" stroke="black" stroke-opacity="0.6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M13.75 2.92402C14.0815 2.5925 14.5312 2.40625 15 2.40625C15.2321 2.40625 15.462 2.45197 15.6765 2.54081C15.891 2.62965 16.0858 2.75986 16.25 2.92402C16.4142 3.08817 16.5444 3.28305 16.6332 3.49752C16.722 3.712 16.7678 3.94187 16.7678 4.17402C16.7678 4.40616 16.722 4.63604 16.6332 4.85051C16.5444 5.06499 16.4142 5.25986 16.25 5.42402L5.83333 15.8407L2.5 16.674L3.33333 13.3407L13.75 2.92402Z" stroke="black" stroke-opacity="0.6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <svg onClick={() => {
                                                    setCategoryId(category.categoryId);
                                                    setIsOpenPopup(true)
                                                    setIsAsk(true);
                                                }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.6">
                                                        <path d="M2.5 5H4.16667H17.5" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M15.8327 4.9974V16.6641C15.8327 17.1061 15.6571 17.53 15.3445 17.8426C15.032 18.1551 14.608 18.3307 14.166 18.3307H5.83268C5.39065 18.3307 4.96673 18.1551 4.65417 17.8426C4.34161 17.53 4.16602 17.1061 4.16602 16.6641V4.9974M6.66602 4.9974V3.33073C6.66602 2.8887 6.84161 2.46478 7.15417 2.15222C7.46673 1.83966 7.89065 1.66406 8.33268 1.66406H11.666C12.108 1.66406 12.532 1.83966 12.8445 2.15222C13.1571 2.46478 13.3327 2.8887 13.3327 3.33073V4.9974" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M8.33398 9.16406V14.1641" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M11.666 9.16406V14.1641" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    </g>
                                                </svg>

                                            </div>
                                        </div>)
                                    }
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {
                imgSrc && (
                    <div className="canvas-holder" style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        zIndex: "10",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#0000009c",
                        flexDirection: "column",
                        top: "0px"
                    }}>
                        <div className='crop_image_holder'>
                            <div className='image_container'>
                                <ReactCrop
                                    crop={crop}
                                    onChange={(_, percentCrop) => setCrop(percentCrop)}
                                    onComplete={(c) => setCompletedCrop(c)}
                                    aspect={aspect}
                                >
                                    <img ref={imgRef} alt="Crop me" src={imgSrc} onLoad={onImageLoad} />
                                </ReactCrop>
                            </div>
                            <div className="image_upload_btn">
                                <button className='upload_btn' onClick={() => {
                                    onDownloadCropClick();
                                    setImgSrc(null)
                                }}>Upload</button>
                                <button className='upload_cancel_btn' onClick={() => setImgSrc(null)}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )
            }

            {/* Hidden Anchor for Download */}
            <a ref={hiddenAnchorRef} style={{ display: 'none' }}></a>

            {/* Hidden Canvas for Cropping */}
            <canvas ref={previewCanvasRef} style={{ display: 'none' }} />
            {isOpenPopUp ?
                <div className='INCSUBCategory_permission_popup'>{
                    isAsk ?
                        <div className='INCSUBCategory_ask_container' >
                            <div className='INCSUBCategory_ask' style={{ display: categoryLoader ? 'none' : null }}>
                                <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="49.0815" cy="46.0102" r="32.0883" fill="#00B64C" />
                                    <path d="M60.983 36.3818C60.8251 36.2039 60.6372 36.0627 60.4301 35.9663C60.223 35.8699 60.001 35.8203 59.7766 35.8203C59.5523 35.8203 59.3302 35.8699 59.1232 35.9663C58.9161 36.0627 58.7282 36.2039 58.5702 36.3818L45.9115 50.5421L40.5932 44.5818C40.4292 44.4049 40.2356 44.2657 40.0234 44.1723C39.8113 44.0789 39.5848 44.0331 39.3568 44.0375C39.1288 44.0419 38.9038 44.0964 38.6947 44.198C38.4855 44.2995 38.2963 44.4461 38.1379 44.6293C37.9795 44.8125 37.8549 45.0288 37.7713 45.2658C37.6877 45.5028 37.6467 45.7558 37.6507 46.0105C37.6546 46.2652 37.7034 46.5166 37.7943 46.7502C37.8852 46.9838 38.0164 47.1952 38.1804 47.3721L44.7051 54.6611C44.8631 54.839 45.051 54.9802 45.2581 55.0766C45.4651 55.1729 45.6872 55.2225 45.9115 55.2225C46.1359 55.2225 46.3579 55.1729 46.565 55.0766C46.7721 54.9802 46.96 54.839 47.1179 54.6611L60.983 39.1721C61.1555 38.9943 61.2932 38.7786 61.3873 38.5385C61.4815 38.2984 61.5301 38.0391 61.5301 37.7769C61.5301 37.5148 61.4815 37.2555 61.3873 37.0154C61.2932 36.7753 61.1555 36.5595 60.983 36.3818Z" fill="white" />
                                    <circle cx="13.778" cy="7.87368" r="7.87368" fill="#00B64C" fill-opacity="0.2" />
                                    <circle cx="93.1719" cy="15.749" r="5.90526" fill="#00B64C" fill-opacity="0.2" />
                                    <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#00B64C" fill-opacity="0.2" />
                                    <circle cx="34.777" cy="91.2028" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                    <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                    <circle cx="89.235" cy="58.3903" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                    <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                </svg>

                                <div className='INCSUBCategory_permission_header'>
                                    Are you sure to delete this category?
                                </div>
                                <div className='INCSUBCategory_permission_btn_container'>
                                    <div className="INCSUBCategory_image_upload_btn">
                                        <div className='INCSUBCategory_upload_btn' onClick={() => handleDeleteCategory(categoryId)}>Delete</div>
                                        <div className='upload_cancel_btn' onClick={() => setIsOpenPopup(false)}>Cancel</div>
                                    </div>
                                </div>
                            </div>
                            {
                                categoryLoader ? <div className='categoryloader' /> : null
                            }
                        </div> : <div className='INCSUBCategory_ask_container'>
                            <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="49.0805" cy="46.0102" r="32.0883" fill="#FF6565" />
                                <path d="M59 37L41 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M41 37L59 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                <circle cx="13.778" cy="7.87368" r="7.87368" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="93.1709" cy="15.749" r="5.90526" fill="#FF6565" fill-opacity="0.2" />
                                <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="34.777" cy="91.2028" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="89.234" cy="58.3903" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                            </svg>
                            <div className='INCSUBCategory_permission_header'>
                                Can’t delete
                            </div>
                            <div className='INCSUBCategory_permission_text'>There are platforms in this category.</div>
                            <div className='INCSUBCategory_permission_btn_container'>
                                <div className="INCSUBCategory_image_upload_btn">
                                    <div className='INCSUBCategory_upload_btn' onClick={() => setIsOpenPopup(false)}>Ok, Got it</div>
                                    {/* <div className='upload_cancel_btn'>Cancel</div> */}
                                </div>
                            </div>
                        </div>
                }


                </div> : null
            }

        </div >
    )
}

export default INCSUBCategory
